var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    transform: "translate(-316 -581)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d5dde5",
    strokeWidth: 1,
    d: "M0 0L0 24",
    "data-name": "Line 1",
    transform: "translate(316.5 581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d5dde5",
    strokeWidth: 1,
    d: "M0 0L0 25",
    "data-name": "Line 2",
    transform: "rotate(90 -132 473)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#d5dde5",
    "data-name": "Ellipse 1",
    transform: "translate(341 601)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomArrow);
export default __webpack_public_path__ + "static/media/custom-arrow.c2e8947297a3220a8ad09dfffe98070f.svg";
export { ForwardRef as ReactComponent };